import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import useAuth from "../../../../../initialpage/hooks/useAuth";
import { API } from "../../../StoreComponents/conflict";
import useGetData from "../../../StoreComponents/hooks/useGetData";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const ManualRequisition = () => {
  const user = JSON.parse(Cookies.get("user") || '{}');
  const { CountData } = useGetData();
  const { mutate } = CountData();
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  // const [employeeOption, setEmployeeOption] = useState([]);
  const [productOption, setProductOption] = useState([]);
  const [selectSingleProduct, setSelectSingleProduct] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productArray, setProductArray] = useState([]);

  // get Enployee data
  const { data: employeeOption, error: error1 } = useSWR(
    `hr/employee`,
    fetcher
  );

  // get categoryData
  const { data: categoryOption, error: error2 } = useSWR(
    `store/settings/categories?page=${0}&limit=${10000}`,
    fetcher1
  );

  // set Employee category select list
  let employeeCategory = [];
  if (employeeOption && employeeOption.length > 0) {
    employeeCategory = employeeOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.EMPLOYEE_ID;
      optionsItem.label = `${data.NAME_ENGLISH}=>${data.DESIGNATION}=>${data.DEPARTEMENT}`;
      return optionsItem;
    });
  }
  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }

  //console.log(selectSingleProduct);
  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.PROID;
      optionsItem.label = `${data.PRONAME} - ${data.PRONAMETWO}`;
      return optionsItem;
    });
  }

  // handle Employee select;
  const handleEmployee = (name) => {
    setSelectedEmployee(name.value);
  };

  // handle product select;
  const handleProduct = (product) => {
    //console.log(product.value);
    setSelectedProduct(product.value);
    const data = productOption.find((item) => item.PROID === product.value);
    setSelectSingleProduct(data);
  };

  // handle Category select;
  const handleCategory = (name) => {
    const id = name.value;
    //console.log(id);
    setSelectedCategory(name.value);
    API.get(
      id ? `store/products/getStoreProductByCategoryId/${id}` : null
    ).then((res) => setProductOption(res.data.data));
  };

  // react hook form
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = (data) => {
    const data1 = selectSingleProduct && selectSingleProduct.PROQTY;
    const data2 = parseInt(data.appqty);

    if (data1 < data2 || data2 === 0) {
      swal({
        title: "OOPS !",
        text: "Approved Quantities Product Are Bigger than Stock Quantities",
        icon: "warning",
        button: "Ok",
      });
    } else {
      const found = productArray.find(
        (item) => item.proid === parseInt(selectedProduct)
      );

      if (found) {
        swal({
          title: "OOPS !",
          text: "Product already in cart",
          icon: "warning",
          button: "Ok",
        });
      } else {
        const product = {
          proid: selectedProduct,
          stockqty: selectSingleProduct ? selectSingleProduct.PROQTY : "",
          prodqty: parseInt(data.prodqty),
          appqty: parseInt(data.appqty),
          procate: selectedCategory,
          remarks: data.remarks,
          name: selectSingleProduct ? selectSingleProduct.PRONAME : "",
          unit: selectSingleProduct ? selectSingleProduct.UNIT : "",
        };
        console.log(product);
        setProductArray([...productArray, product]);
        reset();
      }
    }
  };

  //console.log(selectSingleProduct);
  //console.log(productArray);

  const deleteProduct = (id) => {
    const proceed = window.confirm("Are you sure?");
    if (proceed) {
      const remaining = productArray.filter((product) => product.proid !== id);
      setProductArray(remaining);
    }
  };

  const [buttonLoading, setButtonLoading] = useState(false);
  // //   Handle Submit
  const handleRequest = () => {
    swal({
      title: "Are you sure?",
      //  text: "Once deleted, you will not be able to recover this imaginary file!",
      buttons: true,
      //  dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setButtonLoading(true);

        if (productArray.length > 0) {
          // console.log(productArray);
          const array = productArray.map((product) => {
            const obj = {
              proid: product.proid,
              stockqty: product.stockqty,
              prodqty: product.prodqty,
              appqty: product.appqty,
              procate: product.procate,
              remarks: product.remarks,
              unit: product.unit,
            };
            return obj;
          });
          console.log({
            hrid: parseInt(selectedEmployee),
            requisitionBy: parseInt(user.employe_id),
            approvedby: user?.name_english,
            products: array,
          });
          API.post("store/requisition/manual", {
            hrid: parseInt(selectedEmployee),
            requisitionBy: parseInt(user.employe_id),
            approvedby: user?.name_english,
            products: array,
          }).then((res) => {
            console.log(res);
            if (!res.data.error) {
              swal({
                title: "Thank You !",
                text: "Successfully Added",
                icon: "success",
                button: "Ok",
              });
              PostStoreLog(1, "Store Manual Requisition Create");
              setButtonLoading(false);
              setProductArray([]);
              mutate();
              setSelectedEmployee(null);
            }
          });
        } else {
          alert("Sorry, You dont have any data!");
        }
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  //   console.log(productArray);

  return (
    <>
      <Helmet>
        <title>Manual Requisition - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">Create Manual Requisition</h3>
          </div>

          <div
            style={{ background: "white", borderRadius: "10px" }}
            className="p-3"
          >
            <div className="add_category py-5">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-6 mt-1">
                    <label htmlFor="Department">
                      Employee <span className="color-red">*</span>
                    </label>

                    <Select
                      onChange={handleEmployee}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={employeeCategory}
                      isDisabled={selectedEmployee === null ? false : true}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedEmployee}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-6 mt-1">
                    <label htmlFor="Department">
                      Category <span className="color-red">*</span>
                    </label>

                    <Select
                      onChange={handleCategory}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={category}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedCategory}
                      required
                    />
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-12 col-md-6 col-lg-6 mt-1">
                    <label htmlFor="Department">
                      Product Name <span className="color-red">*</span>
                    </label>

                    <Select
                      onChange={handleProduct}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={productCategory}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedProduct}
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 mt-1">
                    <label htmlFor="StockBalance">
                      Stock Balance <span className="color-red">*</span>
                    </label>
                    <input
                      defaultValue={
                        selectSingleProduct ? selectSingleProduct.PROQTY : ""
                      }
                      type="number"
                      className="input-field-new p-2"
                      readOnly
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mt-1">
                    <label htmlFor="StockBalance">
                      Required Quantity <span className="color-red">*</span>
                    </label>
                    <input
                      {...register("prodqty")}
                      type="number"
                      className="input-field-new p-2"
                      required
                    />
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-12 col-md-12 col-lg-3 mt-1">
                    <label htmlFor="StockBalance">
                      Approved Quantity <span className="color-red">*</span>
                    </label>
                    <input
                      {...register("appqty")}
                      type="number"
                      className="input-field-new p-2"
                      required
                    />
                  </div>
                  <div className="col-12 col-md-12 col-lg-9 mt-1">
                    <label htmlFor="StockBalance">Remark</label>
                    <textarea
                      {...register("remarks")}
                      rows={3}
                      className="input-field-new p-2"
                    />
                  </div>
                </div>

                <div className="text-center">
                  <button
                    type="sumbit"
                    className="mt-5 px-4 btn btn-color_store"
                  >
                    <i className="fa fa-plus"></i>
                    <span> Add</span>
                  </button>
                </div>
              </form>

              {/* Table */}
              <div className="row mt-5">
                <div className="col-12">
                  <div id="printArea" className="table-responsive-sm">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr
                          className="tableColor"
                        >
                          <th>S/N</th>
                          <th>PRODUCT</th>
                          <th>REQUIRED</th>
                          <th>APPROVED</th>
                          <th>REMARKS</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productArray &&
                          productArray.map((product, index) => (
                            <tr key={index}>
                              <th>{++index}</th>
                              <td>{product.name}</td>
                              <td>{product.prodqty}</td>
                              <td>{product.appqty}</td>
                              <td>{product.remarks}</td>
                              <td>
                                <button
                                  onClick={() => deleteProduct(product.proid)}
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  type="button"
                                  className="btn btn-red px-3"
                                >
                                  <i className="fa fa-times fs-6"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {!buttonLoading ? (
                <button
                  onClick={handleRequest}
                  className="btn btn-color_store px-3 mt-4"
                >
                  <i className="fa fa-check" />
                  <span> Submit</span>
                </button>
              ) : (
                <button className="btn btn-color_store px-3 mt-4">
                  <i className="fa fa-check" />
                  <span> Submit</span>

                  <div
                    style={{ width: "20px", height: "20px" }}
                    class="spinner-border ms-2  text-light"
                    role="status"
                  >
                    <span style={{}} class="visually-hidden ">
                      Loading...
                    </span>
                  </div>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManualRequisition;
